module.exports = __webpack_public_path__ + "ce05dccf036cf0a566022996def551e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/whiskers-beak-s.png
// module id = 1217
// module chunks = 0